// function to validate the contact form
export default function contactValidator(formData) {
    // object to store the form errors
    const errors = {}

    const name = formData.name
    const email = formData.email
    const message = formData.message

    if (!name) errors.name = "Name required"
    if (!email) errors.email = "Email required"
    if (email && !/^\S+@\S+\.\S+$/.test(email)) errors.email = "Enter a valid email address"
        
    if (!message) return errors.business = "Message required"

    return errors
}